import { GiveawayResponse } from '@org-avp/avp-hck-dga-customerui-commons';
import { Configuration } from './definitions';

export const extractConfiguration = (giveawayData: GiveawayResponse): Configuration | undefined => {
  if (!giveawayData || !giveawayData.configuration) {
    return undefined;
  }

  const configurationDetails = giveawayData.configuration;
  const { modelVersion } = configurationDetails;

  let modelModelVersion: number | undefined;
  if (modelVersion) {
    const modelVersionNumber = Number.parseInt(modelVersion, 10);
    modelModelVersion = Number.isNaN(modelVersionNumber) ? undefined : modelVersionNumber;
  }

  return {
    CarlineId: configurationDetails.carlineId,
    CarlineName: configurationDetails.carlineName,
    SalesgroupId: configurationDetails.salesgroupId,
    SalesgroupName: configurationDetails.salesgroupName,
    EquipmentlineName: configurationDetails.equipmentlineName,
    EngineName: configurationDetails.engineName,
    EnginePowerHPKW: configurationDetails.enginePower,
    ModelId: configurationDetails.modelId,
    ModelTrimFeatures: configurationDetails.modelTrimFeatures,
    ModelName: configurationDetails.modelName,
    ModelYear: configurationDetails.modelYear,
    ModelModelVersion: modelModelVersion,
    Marketingcode: giveawayData.marketingCode,
  };
};
